import { render, staticRenderFns } from "./relatorioFixo.vue?vue&type=template&id=725e31d1&scoped=true"
import script from "./relatorioFixo.vue?vue&type=script&lang=js"
export * from "./relatorioFixo.vue?vue&type=script&lang=js"
import style0 from "./relatorioFixo.vue?vue&type=style&index=0&id=725e31d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725e31d1",
  null
  
)

export default component.exports